import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation createUserConsent($input: UserConsentCreateInput!) {
    createUserConsent(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      user {
        id
        acceptTerms
        acceptTermsAt
        acceptSms
        acceptMarketing
      }
      accountEvents {
        id
        eventType
        area
      }
    }
  }
  ${ErrorMessageInfo}
`;
